<ion-item class="mb-4 w-full rounded-md" id="via-point" color="light" lines="none" detail="false">
    <ng-container
        *ngTemplateOutlet="
            plannerViaPointWrapper;
            context: {
                JOURNEY_PLANNER_VIA_POINT: ('JOURNEY_PLANNER_VIA_POINT' | translate),
                JOURNEY_PLANNER_VIA_POINT_STOP: ('JOURNEY_PLANNER_VIA_POINT_STOP' | translate),
                JOURNEY_PLANNER_SELECT_STOP: ('JOURNEY_PLANNER_SELECT_STOP' | translate)
            }
        ">
    </ng-container>

    <ion-button
        *ngIf="selectedStop$ | async"
        [attr.aria-label]="'JOURNEY_PLANNER_VIA_POINT_CLEAR' | translate"
        (click)="resetSelection(); $event.stopPropagation()"
        fill="clear"
        size="small"
        slot="end">
        <ion-icon
            [color]="(isContrast$ | async) ? null : 'medium'"
            [ngClass]="{ 'text-contrast-black': isContrast$ | async }"
            aria-hidden="true"
            name="close">
        </ion-icon>
    </ion-button>
</ion-item>

<ng-template
    #plannerViaPointWrapper
    let-JOURNEY_PLANNER_VIA_POINT="JOURNEY_PLANNER_VIA_POINT"
    let-JOURNEY_PLANNER_VIA_POINT_STOP="JOURNEY_PLANNER_VIA_POINT_STOP"
    let-JOURNEY_PLANNER_SELECT_STOP="JOURNEY_PLANNER_SELECT_STOP">
    <div
        class="flex flex-1 items-center"
        [attr.aria-label]="
            JOURNEY_PLANNER_VIA_POINT +
            ', ' +
            JOURNEY_PLANNER_VIA_POINT_STOP +
            ': ' +
            ((selectedStopName$ | async) || JOURNEY_PLANNER_SELECT_STOP)
        "
        (click)="toggleViaPointModal()"
        (keydown.enter)="toggleViaPointModal()"
        (keydown.space)="$event.preventDefault(); toggleViaPointModal()"
        role="button"
        aria-haspopup="dialog">
        <ion-icon
            class="h-[2.375rem] w-5 dark:filter-black"
            title="{{ JOURNEY_PLANNER_VIA_POINT }}"
            src="{{ assetsPath$ | async }}/img/journey-planner/via-point.svg">
        </ion-icon>

        <ion-label class="text-base leading-6" aria-hidden="true">
            <span class="text-ironside_grey dark:text-contrast-black">{{ JOURNEY_PLANNER_VIA_POINT_STOP }}:&nbsp;</span>
            <span *ngIf="selectedStopName$ | async as stopName; else noSelection">{{ stopName }}</span>
            <ng-template #noSelection>
                <span class="text-ironside_grey dark:text-contrast-black">{{ JOURNEY_PLANNER_SELECT_STOP }}</span>
            </ng-template>
        </ion-label>
    </div>
</ng-template>
